export const QueryKeys = {
  editActivity: (activityId: number) => `editActivity-${activityId}`
};
